// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Transition } from './Transition';
import {
  TransitionFromJSON,
  TransitionFromJSONTyped,
  TransitionToJSON,
  TransitionToJSONTyped,
} from './Transition';

/**
 *
 * @export
 * @interface GetTransitionResponse
 */
export interface GetTransitionResponse {
  /**
   *
   * @type {Array<Transition>}
   * @memberof GetTransitionResponse
   */
  data: Array<Transition>;
}

/**
 * Check if a given object implements the GetTransitionResponse interface.
 */
export function instanceOfGetTransitionResponse(
  value: object,
): value is GetTransitionResponse {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function GetTransitionResponseFromJSON(
  json: any,
): GetTransitionResponse {
  return GetTransitionResponseFromJSONTyped(json, false);
}

export function GetTransitionResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetTransitionResponse {
  if (json == null) {
    return json;
  }
  return {
    data: (json['data'] as Array<any>).map(TransitionFromJSON),
  };
}

export function GetTransitionResponseToJSON(json: any): GetTransitionResponse {
  return GetTransitionResponseToJSONTyped(json, false);
}

export function GetTransitionResponseToJSONTyped(
  value?: GetTransitionResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: (value['data'] as Array<any>).map(TransitionToJSON),
  };
}
